import http from "@/http";

// ### 计划任务列表
// http://base.leubao.com/api/cron/cron_list
export const getCronList = {
  p: "/api/cron/cron_list",
  r: data => {
    return http({
      url: "/api/cron/cron_list",
      method: "post",
      data
    });
  }
};

// ### 计划任务详情
// https://api.msg.alizhiyou.cn/cron/details/13
export const getCronInfo = {
  p: "/cron/details",
  r: data => {
    return http({
      url: "/cron/details/" + data.id,
      method: "get"
      // data
    });
  }
};
// ### 添加计划任务
// http://base.leubao.com/api/cron/add
export const addCron = {
  p: "/api/cron/add",
  r: data => {
    return http({
      url: "/api/cron/add",
      method: "post",
      data
    });
  }
};

// ### 修改计划任务
// http://base.leubao.com/api/cron/edit
export const editCron = {
  p: "/api/cron/edit",
  r: data => {
    return http({
      url: "/api/cron/edit",
      method: "post",
      data
    });
  }
};

//### 删除计划任务
// http://base.leubao.com/api/cron/delete
export const deleteCron = {
  p: "/api/cron/delete",
  r: data => {
    return http({
      url: "/api/cron/delete",
      method: "post",
      data
    });
  }
};
// ### 获取计划任务文件列表
// http://base.leubao.com/api/cron/cron_file_list
export const getCronFileList = {
  p: "/api/cron/cron_file_list",
  r: data => {
    return http({
      url: "/api/cron/cron_file_list",
      method: "get",
      data
    });
  }
};
